import { LoadingModule } from '../loading/loading.module';
import { NgModule,NO_ERRORS_SCHEMA,CUSTOM_ELEMENTS_SCHEMA  } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import {CommonModule} from '@angular/common';
import { ResearchTopicDetailsComponent } from './research-topic-details.component';
import { ResearchTopicDetailsRoutingoModule } from './research-topic-details-routing.module';
@NgModule({
  imports: [
    ResearchTopicDetailsRoutingoModule,
    HttpClientModule,
    CommonModule,
    LoadingModule
  ],
  declarations: [ResearchTopicDetailsComponent],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA,
    NO_ERRORS_SCHEMA
  ]
})
export class ResearchTopicDetailsModule { }
